import { render } from "./CartCard.vue?vue&type=template&id=508c3f38"
import script from "./CartCard.vue?vue&type=script&lang=js"
export * from "./CartCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__